<div class="flex flex-row justify-between pb-3 pr-2 relative items-center">
    <div class="flex flex-row items-center">
        <h2 mat-dialog-title class="!pl-0 text-2xl !m-0 font-bold !text-blue-theme-color">{{ heading }} </h2>
    </div>
    <button mat-icon-button class="dialog-close-btn flex items-center justify-center" mat-dialog-close>
        <mat-icon class="text-blue-theme-color text-xl">close</mat-icon>
    </button>
</div>

<mat-dialog-content class="mt-16 pt-4 !py-0">
    <div class="relative w-full">
        <!-- Floating details card on top of the map -->
        <div
            class="absolute top-3 left-3 z-10 max-w-[92%] md:max-w-[520px] rounded-xl border border-[#E6EAF2] bg-white-color/95 backdrop-blur px-4 py-3 shadow-md">
            <div class="flex flex-col items-start justify-between gap-3">
                <div class="flex flex-col gap-1">
                    <div class="flex flex-wrap gap-x-4 gap-y-1 text-sm">
                        <div class="flex items-center gap-2">
                            <span class="text-[#7A869A] font-medium">Tracking ID:</span>
                            <span class="text-[#0B1320] font-semibold">{{"#" + trackingIdText }}</span>
                        </div>
                    </div>
                    <div class="flex items-center gap-2 text-sm">
                        <span class="text-[#7A869A] font-medium">Status:</span>
                        <span class="text-[#0B1320] font-semibold">
                            {{ isOrderPickedUp ? 'En route drop-off' : 'En route pickup' }}
                        </span>
                    </div>

                    <div class="flex flex-wrap gap-x-4 gap-y-1 text-sm">
                        <div class="flex flex-col items-start gap-1">
                            <span class="text-[#7A869A] font-medium">Kms Remaining:</span>
                            <span class="text-[#0B1320] font-semibold">
                                {{ isDistanceUpdating ? 'Updating...' : (distanceRemainingKm + ' km') }}
                            </span>
                        </div>
                        <div class="flex flex-col items-start gap-1">
                            <span class="text-[#7A869A] font-medium">Estimated Time:</span>
                            <span class="text-[#0B1320] font-semibold">
                                {{ isDistanceUpdating ? 'Updating...' : estimatedTime }}
                            </span>
                        </div>
                    </div>
                </div>

                <div class="flex  items-center gap-2">
                    <div class="w-10 h-10 rounded-full overflow-hidden bg-[#F1F5F9] flex items-center justify-center">
                        <img *ngIf="driverProfileImageUrl" [src]="driverProfileImageUrl" alt="Driver profile"
                            class="w-full h-full object-cover" />
                        <mat-icon *ngIf="!driverProfileImageUrl" class="text-blue-theme-color">person</mat-icon>
                    </div>
                    <div class="flex flex-col leading-tight">
                        <span class="text-[#7A869A] text-[11px] font-medium">Driver</span>
                        <span class="text-[#0B1320] text-sm font-semibold">{{ driverNameText }}</span>
                    </div>
                </div>
            </div>
        </div>

        <google-map #map height="600px" width="100%" [center]="mapCenter" [zoom]="zoom">
            <!-- Origin marker (driver) -->

            <!-- Show pickup marker when order is not picked up -->
            <map-marker *ngIf="this.pickupCoords && !isOrderPickedUp" [position]="pickupCoords"
                [options]="{ icon: markerOptions.pickup.icon }">
            </map-marker>

            <!-- Show destination marker when order is picked up -->
            <map-marker *ngIf="dir.destination && isOrderPickedUp" [position]="dir.destination"
                [options]="{ icon: markerOptions.destination.icon }">
            </map-marker>

            <!-- Show waypoint markers when order is picked up -->
            <ng-container *ngIf="isOrderPickedUp">
                <map-marker *ngFor="let wp of waypoints" [position]="wp.location"
                    [options]="{ icon: markerOptions.destination.icon }">
                </map-marker>
            </ng-container>

            <!-- Route path -->
            <map-polyline *ngIf="routePath.length > 1" [path]="routePath" [options]="polylineOptions">
            </map-polyline>
        </google-map>
    </div>
</mat-dialog-content>

<mat-dialog-actions class="!px-0 justify-center">
    <button color="primary" mat-dialog-close
        class="!bg-blue-theme-color md:!w-[130px] sm:!w-full !w-full !h-11 text-white-color" mat-flat-button>
        OK
    </button>
</mat-dialog-actions>